import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { context } from '../../app/context';
import { AlertDialog } from './alert.dialog';

type InsufficiencyReason = 'storage-limit' | 'duplicate-storage' | 'duplicate-tasks';

export type InsufficientResourceDialogProps = {
  reason: InsufficiencyReason;
  onCancel: () => void;
};

export const InsufficientResourceDialog: React.FC<InsufficientResourceDialogProps> = observer(
  ({ onCancel, reason = 'storage-limit' }) => {
    const { t } = useTranslation('common');

    const navigate = context.navigate;
    const space = context.space;

    const currentPlanTaskLimit = space?.features?.tasks?.limit || 5;
    const hasSubscription = space!.hasSubscription();
    const buttonText = hasSubscription ? 'Upgrade storage' : 'Upgrade plan';

    const handleClick = () => {
      if (hasSubscription) {
        navigate(`/space/${space._id}/settings/storage`);
      } else {
        navigate(`/space/${space._id}/settings/plans`);
      }

      onCancel();
    };

    return (
      <AlertDialog
        onCancel={onCancel}
        title={t(`${reason}-title`)}
        description={t(`${reason}-description`, { limit: currentPlanTaskLimit })}
        buttonText={buttonText}
        onAccept={handleClick}
      />
    );
  },
);
